"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformNotificationType = exports.SdPlatformNotificationClass = exports.SdPlatformNotificationLevel = exports.SdPlatformNotificationCreator = void 0;
/**
 * Creator of notification.
 */
var SdPlatformNotificationCreator;
(function (SdPlatformNotificationCreator) {
    /** created by the platform backend itself */
    SdPlatformNotificationCreator["Platform"] = "platform";
    /** created due to some action taken by the user, e.g. for type model-transfer-request */
    SdPlatformNotificationCreator["User"] = "user";
    /** created by webhook call, typically by a geometry backend system */
    SdPlatformNotificationCreator["Webhook"] = "webhook";
})(SdPlatformNotificationCreator = exports.SdPlatformNotificationCreator || (exports.SdPlatformNotificationCreator = {}));
;
/**
 * Level of notification.
 */
var SdPlatformNotificationLevel;
(function (SdPlatformNotificationLevel) {
    /** Information level */
    SdPlatformNotificationLevel["Info"] = "info";
    /** Warning level */
    SdPlatformNotificationLevel["Warning"] = "warning";
    /** Error level */
    SdPlatformNotificationLevel["Error"] = "error";
})(SdPlatformNotificationLevel = exports.SdPlatformNotificationLevel || (exports.SdPlatformNotificationLevel = {}));
;
/**
 * Classification of the notification which can be used to show different tabs of notifications to the user in the platform frontend.
 */
var SdPlatformNotificationClass;
(function (SdPlatformNotificationClass) {
    /** Model-related notification */
    SdPlatformNotificationClass["Model"] = "model";
    /** Account-related notification */
    SdPlatformNotificationClass["Account"] = "account";
    /** Organization-related notification */
    SdPlatformNotificationClass["Organization"] = "organization";
    /** Sharing-related notification */
    SdPlatformNotificationClass["Sharing"] = "sharing";
})(SdPlatformNotificationClass = exports.SdPlatformNotificationClass || (exports.SdPlatformNotificationClass = {}));
;
/**
 * Specific type of notification.
 */
var SdPlatformNotificationType;
(function (SdPlatformNotificationType) {
    SdPlatformNotificationType["ModelTransferRequest"] = "model-transfer-request";
    SdPlatformNotificationType["ModelTransferAccept"] = "model-transfer-accept";
    SdPlatformNotificationType["ModelTransferDeny"] = "model-transfer-deny";
    SdPlatformNotificationType["ModelConfirmed"] = "model-confirmed";
    SdPlatformNotificationType["ModelDenied"] = "model-denied";
    SdPlatformNotificationType["ModelVisibilityChanged"] = "model-visibility-changed";
    SdPlatformNotificationType["ScriptDenied"] = "script-denied";
    SdPlatformNotificationType["ComputationFailed"] = "computation-failed";
    SdPlatformNotificationType["ExportFailed"] = "export-failed";
    SdPlatformNotificationType["CreditLimitWarning"] = "credit-limit-warning";
    SdPlatformNotificationType["CreditLimitError"] = "credit-limit-error";
    SdPlatformNotificationType["ModelShared"] = "model-shared";
    SdPlatformNotificationType["ModelUnshared"] = "model-unshared";
    SdPlatformNotificationType["SavedStateShared"] = "saved-state-shared";
    SdPlatformNotificationType["SavedStateUnshared"] = "saved-state-unshared";
    SdPlatformNotificationType["SavedStateCreated"] = "saved-state-created";
    SdPlatformNotificationType["SavedStateDeleted"] = "saved-state-deleted";
    SdPlatformNotificationType["OrganizationInvitation"] = "organization-invitation";
    SdPlatformNotificationType["OrganizationInvitationAccept"] = "organization-invitation-accept";
    SdPlatformNotificationType["OrganizationInvitationBlocked"] = "organization-invitation-blocked";
    SdPlatformNotificationType["OrganizationInvitationDeny"] = "organization-invitation-deny";
    SdPlatformNotificationType["PluginUpdate"] = "plugin-update";
    SdPlatformNotificationType["OrganizationUserSuspended"] = "organization-user-suspended";
    /**
     * Planned maintenance or downtime.
     */
    SdPlatformNotificationType["Maintenance"] = "maintenance";
    SdPlatformNotificationType["PlatformFrontendUpdate"] = "platform-frontend-update";
    SdPlatformNotificationType["ViewerUpdate"] = "viewer-update";
    SdPlatformNotificationType["GeometryBackendUpdate"] = "geometry-backend-update";
    SdPlatformNotificationType["PlatformBackendUpdate"] = "platform-backend-update";
    /**
     * Updates about components like SDKs etc.
     */
    SdPlatformNotificationType["GenericUpdate"] = "generic-update";
    /**
     * Used whenever a user's or organization's default backend system gets changed by the platform backend.
     */
    SdPlatformNotificationType["BackendSystemChanged"] = "backend-system-changed";
    /**
     * Common.
     */
    SdPlatformNotificationType["Update"] = "update";
    SdPlatformNotificationType["Information"] = "information";
})(SdPlatformNotificationType = exports.SdPlatformNotificationType || (exports.SdPlatformNotificationType = {}));
//# sourceMappingURL=SdPlatformNotificationCommons.js.map